import { render, staticRenderFns } from "./ParksField.vue?vue&type=template&id=5a10e386&scoped=true"
import script from "./ParksField.vue?vue&type=script&lang=ts"
export * from "./ParksField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a10e386",
  null
  
)

export default component.exports